export default {
  CURRENTJOURNEY_ORCHSTEP_COLOR: 'orange',
  CURRENTJOURNEY_PRECONDITION_COLOR: '#F5DADF',
  SELECTED_COLOR: '#90EE90',
  ERROR_NODE: '#ed5249',
  WARNING_COLOR: '#ffeb3b',
};
